import { reducerWithInitialState } from "typescript-fsa-reducers";
import { actions } from "../actions/Action";
import { AuthSettingsInitialState, AuthSettingsState } from "../typing/settingsstate";
import { NO_SECRETS } from "../typing/authSettingsLogic";
import { AuthSettings } from "../typing/generalType";

const withSettings = (state: AuthSettingsState, settings: AuthSettings): AuthSettingsState =>
    ({ ...state, model: { ...state.model, settings } });

export default reducerWithInitialState(AuthSettingsInitialState)
    // Loaded or saved: the typed-in secrets are gone (the hub has them now,
    // or never will), the flags from the hub say whether one is stored.
    .case(actions.settingsLoaded, (state, payload) => ({
        model: { settings: payload.settings, secrets: NO_SECRETS },
        view: { ...state.view, loaded: true, loadFailed: false, saving: false, errors: [] },
    }))
    .case(actions.loadFailed, (state) => ({
        ...state,
        view: { ...state.view, loadFailed: true, saving: false },
    }))
    .case(actions.setProviders, (state, payload) =>
        withSettings(state, { ...state.model.settings, providers: payload.providers }))
    .case(actions.setProvisionRole, (state, payload) =>
        withSettings(state, { ...state.model.settings, provisionRole: payload.role }))
    .case(actions.setLdapField, (state, payload) =>
        withSettings(state, {
            ...state.model.settings,
            ldap: { ...state.model.settings.ldap, [payload.field]: payload.value },
        }))
    .case(actions.setKeycloakField, (state, payload) =>
        withSettings(state, {
            ...state.model.settings,
            keycloak: { ...state.model.settings.keycloak, [payload.field]: payload.value },
        }))
    .case(actions.setSecret, (state, payload) => ({
        ...state,
        model: { ...state.model, secrets: { ...state.model.secrets, [payload.field]: payload.value } },
    }))
    .case(actions.saveStarted, (state) => ({
        ...state,
        view: { ...state.view, saving: true, errors: [] },
    }))
    .case(actions.saveRefused, (state, payload) => ({
        ...state,
        view: { ...state.view, saving: false, errors: payload.errors },
    }))
    .case(actions.setTestResult, (state, payload) => ({
        ...state,
        view: payload.kind === "ldap"
            ? { ...state.view, ldapTest: payload.result }
            : { ...state.view, keycloakTest: payload.result },
    }));
